import {EventStore} from "../../server/EventStore.ts";
import * as Html from "../../util/Html.ts";
import * as FwDatas from "../../FwDatas.ts";
import * as amplify from "../../util/amplify.ts";
import TPL_search from "../../calendar/searchresult.mustache";
import {easyScorer, applyScorer } from "../searchController.ts";
import IHasRecurrencyHelper from "../../lib/IHasRecurrencyHelper.ts"
export {initDom}



Html.registerWidget('widget/specific/calendarsearch',{initDom})

Html.registerDom({
  eventopensearch(){
    const parent = this.parentElement;
    if(parent) parent.classList.add('showsearch');
    const prev = this.previousElementSibling as HTMLElement;
    if(prev) {
      const input = prev.querySelector('input[type=search]') as HTMLInputElement;
      if(input) input.select();
    }
  },
  eventhidesearch(){
    const grandParent = this.parentElement?.parentElement;
    if(grandParent) grandParent.classList.remove('showsearch');
  }
})
var currentDate = new Date();
amplify.subscribe('calendar.currentDate',function(newCurrentDate){
  currentDate = newCurrentDate
})
function CloseToNowComparator(a :HasStartDate ,b :HasStartDate){
  return Math.abs(a.startDate.getTime()-currentDate.getTime())-Math.abs(b.startDate.getTime()-currentDate.getTime())
}

const scorer = easyScorer({text:4,description:2})
function initDom(obj: HTMLElement){
  const resultNode = obj.parentElement?.querySelector('div') as HTMLElement;
  if(!resultNode) return;

  obj.addEventListener('input', function(this: HTMLInputElement){
    const searchText = this.value.trim();
    if(searchText.length>1){
      EventStore.getFor(undefined).then(function(events){

        events = events.map(ev=>{
          const closest = IHasRecurrencyHelper.getClosest(ev,currentDate)
          FwDatas.cache(closest)
          return closest;
        })
        let filtered = applyScorer(events, scorer, searchText).slice(0,30);
        filtered.sort(CloseToNowComparator)
        Html.setHtml(resultNode, TPL_search, filtered);
        resultNode.style.display = '';
      })
    }else{
      resultNode.style.display = 'none';
    }
  })
}